import { useEffect, useMemo, useState, useCallback } from "react";
import InfoItem from '../../components/InfoList/InfoItem'
import { useTranslations } from 'next-intl'
import { APIClient } from '../../helpers/api_helper'

const Index = () => {
    const t = useTranslations('')

    const api = useMemo(() => new APIClient(), []);
    const [settings, setSettings]: any = useState(null);
    const [loading, setLoading]: any = useState(false);

    const fetchSettings = useCallback(async () => {
        try {
            setLoading(true);
            const response: any = await api.get("site/settings/1/", {});
            setSettings(response);
        } catch (error) {
            console.error("Failed to fetch settings:", error);
        } finally {
            setLoading(false);
        }
    }, [api]);

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    return (
      <>
          <div className="work-info gray-background">
              <div className="container-main info-list">
                  {loading ? (
                    <p>{t("Loading")}...</p>
                  ) : (
                    <>
                        <InfoItem
                          count={settings?.property_for_sale}
                          text={t("Property For sale")}
                        />
                        <InfoItem count={settings?.deals} text={t("Deals")} />
                        <InfoItem
                          count={settings?.satisfied_customers}
                          text={t("Satisfied customers")}
                        />
                    </>
                  )}
              </div>
          </div>
      </>
    );
};

export default Index;
